import { useTranslation } from 'react-i18next';
import { Cookie } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useCookieConsent } from '@/hooks/use-cookie-consent';

export function CookieConsent() {
  const { t } = useTranslation('consent');
  const { consent, acceptCookies, rejectCookies } = useCookieConsent();

  // Already answered — don't show
  if (consent !== null) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 p-4 animate-in slide-in-from-bottom duration-500">
      <div className="mx-auto max-w-2xl rounded-lg border-[length:var(--border-brutal)] border-charcoal-950 bg-white p-5 shadow-[4px_4px_0_theme(--color-charcoal-950)] dark:border-charcoal-600 dark:bg-charcoal-900 dark:shadow-[4px_4px_0_theme(--color-charcoal-600)]">
        <div className="flex items-start gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 dark:bg-secondary-900/30">
            <Cookie className="size-5 text-secondary-600 dark:text-secondary-400" />
          </div>
          <div className="flex-1 space-y-3">
            <p className="text-sm font-semibold text-charcoal-900 dark:text-foreground">
              {t('banner_title')}
            </p>
            <p className="text-sm leading-relaxed text-charcoal-600 dark:text-charcoal-300">
              {t('banner_text')}
            </p>
            <div className="flex flex-wrap gap-3">
              <Button size="sm" variant="cta" onClick={acceptCookies} className="min-h-11 px-4">
                {t('accept')}
              </Button>
              <Button size="sm" variant="outline" onClick={rejectCookies} className="min-h-11 px-4">
                {t('reject')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
